import { lazy } from '@wordpress/element';

import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';

import './voucherify-checkout-block';
import './store';

const options = {
	metadata: {
		name: 'voucherify/coupons-form',
		parent: [ 'woocommerce/checkout-totals-block' ],
	},
	component: lazy( () => import('./voucherify-checkout-block') )
};

registerCheckoutBlock( options );

